/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 */

import gql from "graphql-tag";

export const UPLOAD_FILE = gql`
  mutation uploadFile(
    $name: String!
    $data: String!
    $category1: String
    $category2: String
    $addBandName: Boolean
  ) {
    uploadFile(
      name: $name
      data: $data
      category1: $category1
      category2: $category2
      addBandName: $addBandName
    )
  }
`;
